import { Result } from "antd";
import { ModalComponent } from '@operations/shared';

interface Props{
    visibleMessageModal: boolean,
    closeModal: any, 
    resErrorContent?: {
        message: string,
        errorData: string
    }
}

export default function TransactionErrorModal({visibleMessageModal, closeModal, resErrorContent}: Props) {
    return <ModalComponent content={<div className="transactionErrorModal">
        <Result
            status={"error"}
            title={resErrorContent?.message}
        />
        <p>{resErrorContent?.errorData}</p>
    </div>}
        visibleModal={visibleMessageModal} handleAcceptModal={closeModal} handleCloseModal={closeModal} none="none" />
}